export const ID_PREFIX = { HEALTH_PROBE: "mon_healthprobe_" } as const;
